<template>
    <v-stepper
        alt-labels
        elevation="0"
        v-model="currentStep"
        @change="onChangeCurrentStep"
    >
        <v-stepper-header>
            <v-stepper-step
                step="1"
                :complete="currentStep > 1"
                complete-icon="Numeric0"
                id='NumericStep1'
            >
                <span :class="activeClass(1)"> {{ $t('message.adminPage.stepper.step1') }}</span>
            </v-stepper-step>

            <v-divider id="divide1"></v-divider>

            <v-stepper-step
                step="2"
                :complete="currentStep > 2"
                complete-icon="2"
                id='NumericStep2'
            >
                <span :class="activeClass(2)"> {{ $t('message.adminPage.stepper.step2') }}</span>
            </v-stepper-step>
            <v-divider id="divide2"></v-divider>
            <v-stepper-step
                step="3"
                :complete="currentStep > 3"
                complete-icon="3"
                id='NumericStep3'
            >
                <span :class="activeClass(3)"> {{ $t('message.adminPage.stepper.step3') }}</span>
            </v-stepper-step>
        </v-stepper-header>
    </v-stepper>
</template>

<script>
export default {
    props: {
        currentStepProp: String,
    },
    mounted() {
        this.currentStep = JSON.parse(JSON.stringify(this.currentStepProp));
        if (this.currentStep > 1) {
            document.getElementById("divide1").style.borderColor = "orange";
        }
        if (this.currentStep > 2) {
            document.getElementById("divide2").style.borderColor = "orange";
        }
    },
    data() {
        return {
            currentStep: 1,
            isAnnouncePeriod: false,
        };
    },
    computed: {},
    methods: {
        onChangeCurrentStep(step) {
            this.$emit(`onChangeCurrentStep`, step);
        },
        activeClass(step) {
            try {
                if (this.currentStep >= step) {
                    const element = document.getElementById("NumericStep"+step).children[0];
                    const newNode = document.createTextNode(step);
                    element.replaceChild(newNode, element.childNodes[0]);

                    return "active-step-text";
                }
                return "";
            } catch (error) {
                return "";
            }
        },
    },
};
</script>

<style scoped lang="scss">
* {
    font-family: "Prompt";
    .v-application[lang="en"] & {
        font-family: "inter", sans-serif !important;
    }
}
.active-step-text {
    color: #331e00;
    display: flex;
    width: 150px;
    justify-content: center;
    
}


#spanWhite{
    fill: #ffffff;
}
</style>
